<template>
  <div class="gamehistory">
    <v-container class="pt-0">
      <span class="headline">{{$t('gameHistory.title')}}</span>
      <game-list :games="this.games" :loading="loading"></game-list>
    </v-container>
  </div>
</template>

<script>
import { EVENT_REFRESH_DATA } from "@/plugins/eventbus";
import platformMixins from "@/mixins/platformMixins";
import gameTypeMixin from "@/mixins/gameTypeMixin";
import GameList from "@/widgets/GameList";

export default {
  name: "<GameHistory>",
  components: {GameList},
  props: {},
  mixins: [platformMixins, gameTypeMixin],
  data: function() {
    return {
      loading: false,
      games: undefined
    };
  },
  computed: {
  },
  watch: {},
  mounted() {
    this.refreshTable();
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  methods: {
    onRefreshData() {
      this.refreshTable();
    },
    refreshTable() {
      this.loading = true;
      this.$api
        .getGameInstances(["finished"])
        .then(response => {
          this.loading = false;
          this.games = response.data.list;
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    },
  }
};
</script>
